import React from 'react';
import {
  Table,
  Tbody,
  Tr,
  Td,
  Text,
  Heading,
  Box,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';

interface IBlogTableComponentProps {}

const BlogTableComponent: React.FunctionComponent<
  IBlogTableComponentProps
> = () => (
  <Box maxW="1440px" py="20px" overflowX="auto">
    <Table variant="unstyled">
      <Tbody border="1.8px solid" borderColor="bg.seperatorBg">
        <Tr>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Text variant="blogAnswer">
              <Text as="span" color="blue.400">
                #1 – Solinas Integrity
              </Text>{' '}
              is resolving pipeline leaks and tank cleaning issues in the water
              and sanitation industry by developing next-gen pipeline integrity
              management solutions. The robots can detect leaks through
              inspection and analytics, allowing asset managers to take
              preventive maintenance actions. They are also reducing dangerous
              environments for manual septic tank cleaners by developing devices
              capable of homogenizing the hard sludge of septic tanks and
              pumping slurry using an integrated suction mechanism.
            </Text>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Text variant="blogAnswer">
              <Text as="span" color="blue.400">
                #2 – XYMA -
              </Text>{' '}
              XYMA Analytics provides novel ultrasonic sensors and
              Industrial-loT solutions to industries that use hightemperature
              processes, such as refineries, power plants, steel plants, and
              other manufacturing industries. Their sensors provide dense
              measurements across a unit, boosting performance and asset life,
              and are combined with Al-powered physical models for intelligent
              assistance.
            </Text>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Text variant="blogAnswer">
              <Text as="span" color="blue.400">
                #3 – ZenPulsar -
              </Text>{' '}
              ZeNPulsar is the first European-based DeepTech Cyber Forensics
              service dedicated to advancing online integrity. ZeNPulsar uses
              revolutionary Al technology to defend businesses against the
              increasing threat of online disinformation campaigns by detecting
              & predicting social-media manipulation. ZeNPulsar proactively
              locates and neutralizes disinformation, misinformation and
              &quot;fake news&quot; campaigns.
            </Text>
          </Td>
        </Tr>
        <Tr>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Market/Problem
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  A huge Untapped Market of ~800 Million is projected to grow at
                  20% CAGR.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Highly Disorganized sector, Manually driven without much
                  automation.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  • Currently, $14 B is lost in utilities worldwide because of
                  Non-revenue water.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  70% of treated water gets contaminated in transport.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  More than 75 Million Septic tank users, all cleaned manually.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  1000+ workers die every year cleaning tanks/sewers.
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Market/Problem
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Current sensors have limited sensing capabilities, and
                  failures can cause multiple operational issues leading to
                  output losses.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Due to measurement errors or sensor failure, a chemical plant
                  loses $3,000/hr, and a refinery plant loses $200- 350K/hr
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  No direct competitors for the technology, even at a global
                  level. Indirect competitors include conventional sensor
                  manufacturers like Emerson, Omega, WIKA, and Honeywel
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Market/Problem
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Increasing demand from across the Financial Services Sector
                  for Alternative Data financial information derived from
                  non-traditional sources offers investors a holistic investment
                  analysis when combined with traditional data sources
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  The global Alternative Data market will grow from $1.70B in
                  2020 to $2.41B in 2021 (CAGR of 41.4%) and is expected to
                  reach $8.98B in 2025 at a CAGR of 39%.
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
        </Tr>
        <Tr>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Social Impact
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  India banned manual scavenging under the Prohibition of
                  Employment as Manual Scavengers and their Rehabilitation Act,
                  2013 (PEMSR)
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  • Solinas impact 6 UN SDG Goals: Clean water and sanitation;
                  Industry innovation and Infrastructure; Sustainable cities and
                  communities; Responsible consumption and production; Life
                  below water; Partnerships for the goals
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Customers/Traction
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  XYMA sensors are already installed at the BPCL Mumbai
                  refinery. (resulted in a monetary benefit of about 175 Crores
                  in FY 2020 and 75 Crores in FY 2021)
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  A commitment of $200K in FY 21-23 from IOCL, Lam Research,
                  Reliance, SGRI, and Vedanta
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px" textAlign="left">
              Key Capabilities/Competitive Advantages
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  ZeNPulsar provides a unique SaaS solution to detect and
                  predict market manipulation induced by coordinated activity
                  and/or disinformation on social media
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  They measure the impact of certain groups/classes/networks of
                  influencers on the social media momentum and certain groups of
                  retail investors.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  With the data collected and analysis performed, they are able
                  to alert interested parties (e.g. hedge funds in the opposite
                  position or exchange risk management) about possible events
                  and forecast monetary effects.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Not only reactive reporting real-time but also forecasting
                  based on an exclusive data analysis framework.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Customizable solutions-e.g. specific input for client models
                  in case of quant funds and alerts produced by our own models
                  for other clients
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
        </Tr>
        <Tr>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Business Model/Traction
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Solinas intends to reduce non-revenue water by 20% in 10 years
                  and eliminate
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Solinas expects to generate 60% of revenue from product sales
                  (45% from HomoSEP and 15% from Endobot), 25% through AMC, and
                  15% from consultancy.
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Negotiations are going on with Veolia, L&T, and government
                  bodies.
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Product Fit/Business Model
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  XYMA is enhancing industrial efficiency by developing patented
                  Industrial IoT enabled &quot;Ultrasonic Waveguide&quot;
                  technology to improve productivity and asset life
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  XYMA soft sensing Tool uses a physics-based model along with
                  the sensor data to improve the measurement and Prognosis of
                  the asset conditions to the end-user
                </Text>
              </ListItem>
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  XYMA plans to generate 50% of revenue from the direct sale of
                  the products, 30% from SaaS (Dashboard licensing, Data
                  analysis), and 20% from services, AMC
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td minW="320px" />
        </Tr>
        <Tr>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            valign="top"
            minW="320px"
          >
            <Heading variant="blogQuestion" py="20px">
              Team/Awards
            </Heading>
            <UnorderedList pl="16px">
              <ListItem pb="4px">
                <Text variant="blogAnswer">
                  Solinas already has 8 Patents for its technologies. The team
                  has received multiple grants and awards for the company from
                  the Federation of Indian Chambers of Commerce & Industry,
                  TANSEED, CCamp & BIRAC, the honourable prime minister Narendra
                  Modi, and the honourable chief minister of TN, Thiru. MK
                  Stalin.
                </Text>
              </ListItem>
            </UnorderedList>
          </Td>
          <Td
            borderRight="1.8px solid"
            borderColor="bg.seperatorBg"
            minW="320px"
          />
          <Td />
        </Tr>
      </Tbody>
    </Table>
  </Box>
);

export default BlogTableComponent;
